import classnames from 'classnames';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eventbrite/i18n';
import Image from '../Image';

import './basePackage.scss';

export default class BasePackage extends PureComponent {
    static propTypes = {
        /*
        Name of package
        */
        name: translationPropType,
        /*
        Description of package
        */
        description: translationPropType,
        /*
        Fix height of marketing-text-container in <Pricing />
        */
        fixedHeight: PropTypes.bool,
        /*
        Align center on mobile and left otherwise
        */
        adaptiveTextAlign: PropTypes.bool,
        /*
        Logo background color
        */
        logoBgColor: PropTypes.string,
        /*
        Path to logo image
        */
        logoImg: PropTypes.string,
        /*
        Width of the logo
        */
        logoWidth: PropTypes.number,
        /*
        Height of the logo
        */
        logoHeight: PropTypes.number,
        /*
        If true, package will be stylistically prominent
        */
        isProminentPackage: PropTypes.bool,
        /*
        Returns true if screensize is smaller
        */
        isSmallScreen: PropTypes.bool,
    };

    render() {
        const {
            name,
            adaptiveTextAlign,
            description,
            logoBgColor,
            logoImg,
            logoWidth,
            logoHeight,
            isProminentPackage,
            isSmallScreen,
        } = this.props;
        const descriptionClassNames = classnames(
            'package-description',
            'eds-text-bl eds-text--center eds-text-color--grey-600',
            'eds-l-mar-vert-2 eds-l-pad-hor-10',
            {
                'base-package--adaptive-text-align': adaptiveTextAlign,
                'eds-l-mar-vert-8': logoImg,
            },
        );
        const logoBgClass = classnames(
            'package-logo',
            `eds-bg-color--${logoBgColor}`,
            'eds-align--center-vertical',
            {
                'package-logo--standard': !isProminentPackage,
                'package-logo--standard__border': logoBgColor === 'white',
                'package-logo--prominent': isProminentPackage && !isSmallScreen,
                'package-logo--prominent__small':
                    isProminentPackage && isSmallScreen,
            },
        );

        let packagesDisplay = (
            <div className="eds-l-mar-hor-10 eds-text--center">
                <a
                    className="eds-text-hs eds-text-color--grey-900 package-heading--link"
                    href={`/organizer/overview`}
                >
                    {name}
                </a>
            </div>
        );

        if (logoImg) {
            packagesDisplay = (
                <div className={logoBgClass}>
                    <Image
                        altDescription={name}
                        imagePath={logoImg}
                        isFullWidth={false}
                        width={logoWidth}
                        height={logoHeight}
                        bgSize="cover"
                        __backgroundContainerClassName="package-logo-container"
                        isSVG={true}
                    >
                        <span className="eds-is-hidden-accessible">{name}</span>
                    </Image>
                </div>
            );
        }

        return (
            <section>
                {packagesDisplay}
                <h2 className={descriptionClassNames}>{description}</h2>
            </section>
        );
    }
}
